'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/base-components/standard-bar.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
var _grid = require('@marmalade/grid');
var _headerContent = require('./header-content');
var _headerContent2 = _interopRequireDefault(_headerContent);
var _logo = require('./logo');
var _logo2 = _interopRequireDefault(_logo);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

// Just the bar - with themeable background color

var _componentThemes$head = _themes.componentThemes.header,
  headerStyle = _componentThemes$head.headerStyle,
  headerTheme = _componentThemes$head.headerTheme;
var headerBarStyles = function headerBarStyles(props) {
  var theme = headerTheme(props.theme);
  return {
    background: theme[headerStyle('background')],
    backgroundColor: theme[headerStyle('backgroundColor')]
  };
};
var Wrapper = (0, _glamorous2.default)('div')(headerBarStyles);
StandardBar.propTypes = {
  children: _propTypes.node,
  tablet: _propTypes.bool,
  logoProps: _propTypes.object,
  noContainer: _propTypes.bool
};
StandardBar.defaultProps = {
  children: undefined,
  noContainer: false
};
function StandardBar(props) {
  var theGuts = _react2.default.createElement(_headerContent2.default, {
    noContainer: props.noContainer,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37
    },
    __self: this
  }, _react2.default.createElement(_logo2.default, Object.assign({}, props.logoProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38
    },
    __self: this
  })), props.children);
  return _react2.default.createElement(Wrapper, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42
    },
    __self: this
  }, props.noContainer ? theGuts : _react2.default.createElement(_grid.Container, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42
    },
    __self: this
  }, theGuts));
}
exports.default = StandardBar;